
import React from "react";
import IconDescriptionComponent from "./IconDescriptionComponent";
import styles from "./Service.module.css";
import { ServicesTypes } from "@/types/displayData/ServicesTypes";

const ServiceComponent: React.FC<ServicesTypes> = ({
  sectionHeader,
  sectionMainTitle,
  sectionDescription,
  services,
}) => {
  return (
    <section className={styles.servicesContainer}>
      <div className={styles.textSection}>
        <h2 className={styles.header}>{sectionHeader}</h2>
        <h3 className={styles.mainTitle}>{sectionMainTitle}</h3>
        <p className={styles.description}>{sectionDescription}</p>
      </div>

      <div className={styles.servicesGrid}>
        {services.map((service, index) => (
          <div key={index} className={styles.serviceCard}>
            <div className={styles.iconContainer}>
              <IconDescriptionComponent iconName={service.serviceIcon} />
            </div>
            <h4 className={styles.serviceTitle}>{service.serviceTitle}</h4>
            <p className={styles.serviceDescription}>{service.serviceDescription}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceComponent;
